import { Directive, OnInit } from 'angular-ts-decorators';
import { Printer } from '@shared/app/scripts/services/printer';

/**
 * Main application component to be used @ the top of the application DOM tree;
 * place to include DOM changes to be done globally.
 */
@Directive({
  selector: 'swApp',
  template: require('./sw-app.html').default,
  restrict: 'E',
  transclude: true,
})
export class SwAppComponent implements OnInit {
  constructor(
    private printer: Printer,
    private $scope,
  ) {
    'ngInject';
  }

  ngOnInit() {
    this.printer.setBrowserCallback((content) => {
      this.$scope.printContent = content;
    });
  }
}
